import { gql, useQuery } from '@apollo/client'

import {
  ConsoleSideMenuInfoQuery,
  ConsoleSideMenuInfoQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useCurrentUser } from '@/core'

// コンソール画面のサイドバーの表示に必要なデータを取得する
export const useGetArtistSideMenuInfo = () => {
  const { user } = useCurrentUser()
  const { data } = useQuery<
    ConsoleSideMenuInfoQuery,
    ConsoleSideMenuInfoQueryVariables
  >(QUERY, {
    variables: {
      artistId: user?.uid,
    },
  })

  return {
    user,
    paymentType: data?.artist?.paymentType ?? null,
    hasArrangingDeliveryItems: data?.artist?.hasArrangingDeliveryItems,
    membership: data?.artist?.subscription?.products ?? undefined,
  }
}

const QUERY = gql`
  query ConsoleSideMenuInfo($artistId: ID) {
    artist(id: $artistId) {
      id
      paymentType
      hasArrangingDeliveryItems
      subscription {
        products {
          productId
        }
      }
    }
  }
`
